export const USER_GUIDE_URL =
  'https://www.pemsa-rejiband.com/wp-content/uploads/2016/10/PemsaPro-Online-Guia-de-Usuario.pdf';
export const VIDEO_TUTORIAL_URL = 'https://www.youtube.com/watch?v=FuZmlfohpjU&feature=youtu.be';
export const LOGOUT_URL = 'https://www.pemsa-rejiband.com/';
